module.exports = __webpack_public_path__ + "08e701045146767aad507ffba0919d74.gif";